import React from "react";
import { Box, Grid } from '@mui/material';
import {useNavigate,NavLink} from "react-router-dom";
import classes from "./availabilityappcontrols.module.scss";
import { CheckIsUserAdmin } from "../../../Shared/Utill/Utills";
import { SearchIcon } from "../../../Resources/availabilityicon/IconUtils";
import {AllControlSearchView} from "../../AdminControls/AvailabilityAppControls/RuleAssignments/Search/RuleAssignmentsSearch"

const AvailabilityAppControlsTiles = () => {
    const navigate = useNavigate();
    CheckIsUserAdmin();

    return( 
            <div className={classes.pagemargin}>
            <AllControlSearchView /> 
            <div className={classes.pagetitle} >Availability Application Controls </div>
            <div className={classes.pagesubtitle}>Select the task you'd like to perform. </div>
            
         <Grid container spacing={2} >
            <Grid key={1} item xs={3}>
                <Box className={classes.tilebtnspecial} onClick={() => navigate("/controls/availabilityapplicationcontrols/workschedulegrouping")}  component='span' sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <div className={classes.textbtntitle}>Work Schedule Grouping</div>
                    <div className={classes.textbtnsubtitle}>Manage work schedule groupings.</div>
                </Box>
             </Grid>
            <Grid key={2} item xs={3}>
                <Box className={classes.tilebtnspecial} onClick={() => navigate("/controls/availabilityapplicationcontrols/rules")}  component='span' sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <div className={classes.textbtntitle}>Rules</div>
                    <div className={classes.textbtnsubtitle}>Create new rules.</div>
                </Box>
             </Grid>
            
             <Grid key={3} item xs={3}>
                <Box className={classes.tilebtnspecial} onClick={() => navigate("/controls/availabilityapplicationcontrols/ruleassignments")} component='span' sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <div className={classes.textbtntitle}>Rule Assignments</div>
                    <div className={classes.textbtnsubtitle}>Assemble Group ID and Rule ID for assignment.</div>
                </Box>
             </Grid>
             <Grid key={4} item xs={3}>
                <Box className={classes.tilebtnspecial} onClick={() => navigate("/controls/availabilityapplicationcontrols/cutoffcalendar")} component='span' sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <div className={classes.textbtntitle}>Cutoff Calendar</div>
                    <div className={classes.textbtnsubtitle}>Controls to define when weeks are locked.</div>
                </Box>
             </Grid>
             </Grid>
            <Grid container spacing={2} sx={{ marginTop: 0 }}>
            <Grid key={5} item xs={3}>
                <Box className={classes.tilebtnspecial} onClick={() => navigate("/controls/availabilityapplicationcontrols/locationcontrols")} component='span' sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <div className={classes.textbtntitle}>Location Controls</div>
                    <div className={classes.textbtnsubtitle}>Manage location level controls.</div>
                </Box>
             </Grid>
            </Grid>
            
          
 </div>);

}

export default AvailabilityAppControlsTiles;